import Button from '@zenbusiness/zui/Button';
import Menu from '@zenbusiness/zui/Menu';
import { styled } from '@zenbusiness/zui/styles';

export const MenuStyled = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    padding: '8px 0',
    border: `1px solid ${theme.palette.border.main}`,
    boxShadow: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)',
    borderRadius: '16px'
  }
}));

export const ButtonStyled = styled(Button)(() => ({
  padding: '0',
  borderRadius: '0',
  outline: 'none',
  '&:focus': {
    outline: 'none'
  }
}));
